
import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import VehicleSearch from '../../search/VehicleSearch';

export default (props) => {
  return <FormInputTagsItem {...props} inputComponent={VehicleSearch} />;
};
